/* eslint-disable no-param-reassign */
import { Editor, Range, Point, Element } from 'slate';

export const withTable = (editor: any) => {
	const { deleteBackward, deleteForward, insertBreak } = editor;

	editor.deleteBackward = (unit: any) => {
		const { selection } = editor;
		if (selection) {
			const [cell] = Editor.nodes(editor, {
				match: (n: any) => !Editor.isEditor(n) && Element.isElement(n) && (n as any).type === 'table-cell',
			});
			const prevNodePath = Editor.before(editor, selection);

			const [tableNode] = Editor.nodes(editor, {
				at: prevNodePath,
				match: (n: any) => !Editor.isEditor(n) && Element.isElement(n) && (n as any).type === 'table-cell',
			});

			if (cell) {
				const [, cellPath] = cell;

				const start = Editor.start(editor, cellPath);
				if (Point.equals(selection.anchor, start)) {
					return;
				}
			}
			if (!cell && tableNode) {
				return;
			}
		}

		deleteBackward(unit);
	};

	editor.deleteForward = (unit: any) => {
		const { selection } = editor;
		if (selection && Range.isCollapsed(selection)) {
			const [cell] = Editor.nodes(editor, {
				match: (n: any) => !Editor.isEditor(n) && Element.isElement(n) && (n as any).type === 'table-cell',
			});

			const prevNodePath = Editor.after(editor, selection);
			const [tableNode] = Editor.nodes(editor, {
				at: prevNodePath,
				match: (n: any) => !Editor.isEditor(n) && Element.isElement(n) && (n as any).type === 'table-cell',
			});

			if (cell) {
				const [, cellPath] = cell;
				const end = Editor.end(editor, cellPath);

				if (Point.equals(selection.anchor, end)) {
					return;
				}
			}
			if (!cell && tableNode) {
				return;
			}
		}

		deleteForward(unit);
	};

	return editor;
};
